/**
 * web
 */
'use strict';
import 'picturefill';
import ImgLoaded from '@/_modules/ImgLoaded';
import AppVue from '@/_modules/app-vue';

window.g5M = [];
window.g5M.isLoaded = false;

const tagHTML = document.getElementsByTagName('html')[0];
const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  tagHTML.classList.add('5m-mobile');
  window.g5M.isDevice = 'mobile';
  window.g5M.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  tagHTML.classList.add('5m-mobile');
  window.g5M.isDevice = 'mobile';
  window.g5M.isAndroid = true;
} else {
  tagHTML.classList.add('5m-pc');
  window.g5M.isDevice = 'pc';
  window.g5M.isAndroid = false;
}

const imgUrls = [
  '/assets/img/mv/photo1.jpg',
  '/assets/img/mv/photo2.jpg',
  '/assets/img/mv/photo3.jpg',
  '/assets/img/mv/photo4.jpg',
  '/assets/img/mv/photo5.jpg',
];

// Preload images
const preloadImages = () => {
  return new Promise((resolve, reject) => {
    new ImgLoaded(imgUrls, resolve);
  });
};

// ブラウザ処理
document.addEventListener('DOMContentLoaded', () => {
  new AppVue();

  preloadImages().then((items) => {
    window.g5M.isLoaded = true;
  });
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

/*
Number.isNaN = Number.isNaN || function(any) {
  return typeof any === 'number' && isNaN(any);
};

Number.prototype.map = function(in_min, in_max, out_min, out_max) {
  return ((this - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
};
*/
